import { FullScreen } from './controls/full-screen'
import { PictureInPicture } from './controls/picture-in-picture'
import { PlayBigButton } from './controls/play-big-button'
import { PlayPause } from './controls/play-pause'
import { ProgressBar } from './controls/progress-bar'
import { SeekButtons } from './controls/seek-buttons'
import { VideoTime } from './controls/video-time'
import { Volume } from './controls/volume'
import { getControlItem } from './utils/helpers'
import { ControlBarOptionsType } from './videoplayer-types'

export class ControlBar {
  private wrapperElement: HTMLDivElement
  private videoPlayer: HTMLVideoElement
  private controlBarOptions: ControlBarOptionsType
  private controlBar: HTMLElement
  private topSectionControlBar: HTMLElement
  private leftSectionControlBar: HTMLElement
  private rightSectionControlBar: HTMLElement

  constructor(element: HTMLDivElement, videoPlayer: HTMLVideoElement, options: ControlBarOptionsType) {
    this.wrapperElement = element
    this.videoPlayer = videoPlayer
    this.controlBarOptions = options
    this.init()
  }

  private init() {
    this.renderControlBar()
    this.registerActiveUserEvent()
  }

  private registerActiveUserEvent() {
    let timeout
    this.wrapperElement.addEventListener('mousemove', () => {
      clearTimeout(timeout)
      this.wrapperElement.dataset.userActive = 'true'
      timeout = setTimeout(() => {
        this.wrapperElement.dataset.userActive = `${this.wrapperElement.dataset.videoIsPlaying !== 'true'}`
      }, 3000)
    })
  }

  private renderControlBar() {
    this.controlBar = getControlItem({
      parent: {
        element: 'div',
        classes: ['cmp-video-wrapper__controls'],
      },
    })
    this.renderSections()
    this.renderControls()
    this.wrapperElement.appendChild(this.controlBar)
  }

  private renderSections() {
    this.renderTopSection()
    this.renderLeftSection()
    this.renderRightSection()
  }

  private renderTopSection() {
    this.topSectionControlBar = getControlItem({
      parent: {
        element: 'div',
        classes: ['cmp-video-wrapper__controls--top-section'],
      },
    })
    this.controlBar.appendChild(this.topSectionControlBar)
  }

  private renderLeftSection() {
    this.leftSectionControlBar = getControlItem({
      parent: {
        element: 'div',
        classes: ['cmp-video-wrapper__controls--left-section'],
      },
    })
    this.controlBar.appendChild(this.leftSectionControlBar)
  }

  private renderRightSection() {
    this.rightSectionControlBar = getControlItem({
      parent: {
        element: 'div',
        classes: ['cmp-video-wrapper__controls--right-section'],
      },
    })
    this.controlBar.appendChild(this.rightSectionControlBar)
  }

  private renderControls() {
    new PlayBigButton(this.wrapperElement, this.videoPlayer, this.wrapperElement)

    if (this.controlBarOptions.progressBar) {
      new ProgressBar(this.topSectionControlBar, this.videoPlayer, this.wrapperElement)
    }

    if (this.controlBarOptions.playAndPauseButton) {
      new PlayPause(this.leftSectionControlBar, this.videoPlayer, this.wrapperElement)
    }

    if (this.controlBarOptions.seekButtons) {
      new SeekButtons(this.leftSectionControlBar, this.videoPlayer, this.wrapperElement)
    }

    if (this.controlBarOptions.volumeDisplay) {
      new Volume(this.leftSectionControlBar, this.videoPlayer, this.wrapperElement)
    }

    if (this.controlBarOptions.currentTimeDisplay) {
      new VideoTime({
        element: this.leftSectionControlBar,
        wrapperElement: this.wrapperElement,
        videoPlayer: this.videoPlayer,
        updateProgressBar: this.controlBarOptions.progressBar,
      })
    }

    if (this.controlBarOptions.pictureInPictureToggle) {
      new PictureInPicture(this.rightSectionControlBar, this.videoPlayer, this.wrapperElement)
    }

    if (this.controlBarOptions.fullScreenDisplay) {
      new FullScreen(this.rightSectionControlBar, this.videoPlayer, this.wrapperElement)
    }
  }
}
